/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MediaUiCirclePlayIcon16Light } from './MediaUiCirclePlayIcon16Light';
import { MediaUiCirclePlayIcon16Regular } from './MediaUiCirclePlayIcon16Regular';
import { MediaUiCirclePlayIcon16Solid } from './MediaUiCirclePlayIcon16Solid';
import { MediaUiCirclePlayIcon20Light } from './MediaUiCirclePlayIcon20Light';
import { MediaUiCirclePlayIcon20Regular } from './MediaUiCirclePlayIcon20Regular';
import { MediaUiCirclePlayIcon20Solid } from './MediaUiCirclePlayIcon20Solid';
import { MediaUiCirclePlayIcon24Regular } from './MediaUiCirclePlayIcon24Regular';
import { MediaUiCirclePlayIcon24Solid } from './MediaUiCirclePlayIcon24Solid';
import { MediaUiCirclePlayIcon32Regular } from './MediaUiCirclePlayIcon32Regular';
import { MediaUiCirclePlayIcon64Regular } from './MediaUiCirclePlayIcon64Regular';
var sizes = {
    16: {
        light: MediaUiCirclePlayIcon16Light,
        regular: MediaUiCirclePlayIcon16Regular,
        solid: MediaUiCirclePlayIcon16Solid,
    },
    20: {
        light: MediaUiCirclePlayIcon20Light,
        regular: MediaUiCirclePlayIcon20Regular,
        solid: MediaUiCirclePlayIcon20Solid,
    },
    24: {
        regular: MediaUiCirclePlayIcon24Regular,
        solid: MediaUiCirclePlayIcon24Solid,
    },
    32: {
        regular: MediaUiCirclePlayIcon32Regular,
    },
    64: {
        regular: MediaUiCirclePlayIcon64Regular,
    },
};
export var MediaUiCirclePlayIcon = forwardRef('MediaUiCirclePlayIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
